import { VacancyFormInput } from '../types';

export const generateVacancyFormData = (cv): VacancyFormInput => {
    const baseData = {
        name: cv.name,
        email: cv.email,
        phone: cv.phone,
        message: cv.message,
        vacancy_id: cv.vacancy_id,
    } as VacancyFormInput;

    if (Object.prototype.hasOwnProperty.call(cv, 'document')) {
        baseData.filename = cv.filename;
        baseData.document = cv.document;
    }

    return baseData;
};